import { ReactNode } from "react";

type Props = {
  children: ReactNode;
  additionalClassNames?: string;
};

export const PageContent = (props: Props) => {
  return <div className={`content ${props.additionalClassNames}`}>{props.children}</div>;
};
